import { AI_API_SERVICE } from '@eggplant/api-hosts'
import { AuthenticatedDataRequest } from '@eggplant/data-request'
import type {
  GetExecutionStepsQuery,
  GetTestConfigStepsResponse
} from '@eggplant/types'
import type { ReactElement } from 'react'

interface Props {
  onSuccess: (response: GetTestConfigStepsResponse) => void
  params: GetExecutionStepsQuery
  children?: (response: GetTestConfigStepsResponse) => ReactElement
}

const GetAiExecutionsRequest = ({
  onSuccess,
  params,
  children
}: Props) => {
  const url = `${AI_API_SERVICE}/executions`

  return (
    <AuthenticatedDataRequest
      children={children}
      method='get'
      onSuccess={onSuccess}
      params={params}
      url={url}
    />
  )
}

export default GetAiExecutionsRequest
